import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/CustomerConstants";
import ItemService from "../../../services/human_resource_appCommonService";
import { workflow } from "../../../redux/feature/customer_app/customerSlice";
import { formatDate } from "../../../common/Validations";
import TaskCreationModel from "./TaskCreationModel";
import HRConstants from "../../../common/HRConstants";
import { addTaskNr, getTaskList } from "../../../redux/feature/hr_app/hrSlice";
import { getModuleStats } from "../../../redux/feature/warehouse_app/warehouseSlice";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import { Toast } from "react-bootstrap";
import toast from "react-hot-toast";
import CancelModal from "../../../Components/CancleModal/CancelModal";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import TaskDelegationModal from "./TaskDelegationModal";

const TaskManagementList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Task Manage");
  localStorage.setItem("submenu", "Task List");
  let taskData = useSelector((state) => state?.hr?.task);
  let taskTable = useSelector((state) => state?.hr?.task?.pagination);
  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [modalGateShowStatus, setModalGateShowStatus] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [actionType, setActionType] = useState("Cancel");
  const [getSelectedRows, setSelectedRows] = useState([]);
  const [singleCancelRow, setSingleCancelRow] = useState(null);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [showDelegationModal, setShowDelegationModal] = useState(false);
  const [selectedTaskNr, setSelectedTaskNr] = useState("");

  const moduleStats = useSelector((state) => state.warehouse.moduleStats.data);
  const statsPayload = {
    dashboard: "hr_module",
    chartFilterType: "Yearly",
    chartInput2: new Date().getFullYear(),
  };
  const showDelegation = (taskNr) => {
    setSelectedTaskNr(taskNr);
    setShowDelegationModal(true);
  };
  const DEFAULT_LIST_PARAMS = {
    queryName: "Get_HRTaskManage_List",
    module: "",
    page: 1,
    per_page: 10,
  };

  // const refreshWarehousePage = () => {
  //   dispatch(getTaskList(DEFAULT_LIST_PARAMS));
  //   dispatch(getModuleStats(statsPayload));
  // };

  const refreshWarehousePage = async () => {
    try {
      await dispatch(getTaskList(DEFAULT_LIST_PARAMS));
      await dispatch(getModuleStats(statsPayload));
    } catch (error) {
      console.error("Error refreshing task list:", error);
    }
  };

  useEffect(() => {
    refreshWarehousePage();
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    if (!showStats) {
      const newData = taskData?.data || [];

      setData(newData);
      setFilteredData(newData);
    }
  }, [showStats, taskData?.data]);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  const cancelModalShow = (row = null, type = "Cancel") => {
    setActionType(type);
    if (row) {
      setSingleCancelRow(row);
    } else {
      setSingleCancelRow(null);
    }
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
    setSingleCancelRow(null);
    setActionType("Cancel");
  };
  const cancelRows = singleCancelRow ? [singleCancelRow] : getSelectedRows;
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) =>
        item?.headerStatus !== "Cancelled" && item?.headerStatus !== "Deleted",
    );
    setSelectedRows(validRows);
    setSelectedRowIds(validRows.map((item) => String(item.taskNr)));
  };
  const detailedPage = (tasKId) => {
    dispatch(addTaskNr(tasKId));
    navigate(HRConstants.HR_TASK_DETAILS);
  };
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const loadInitialSuuplierData = async () => {
    setData(taskData?.data);
  };
  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_HRTaskManage_List",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getTaskList(obj));
    // setData(taskData?.data);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_HRTaskManage_List",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getTaskList(obj));
    setData(taskData?.data);
  };
  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };
    fetchData();
    loadInitialSuuplierData();
    dispatch(workflow({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskData?.data]);
  useEffect(() => {
    let obj = {
      queryName: "Get_HRTaskManage_List",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getTaskList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCancelAPI = async (modalPayload = {}) => {
    try {
      const rows = singleCancelRow ? [singleCancelRow] : getSelectedRows;

      const payload = {
        documentNumber: rows.map((item) => item.taskNr),
        actionType,
        cancellationRemark: modalPayload?.cancellationRemark || "",
      };

      const res = await ItemService.cancelOrDeleteTask(payload);

      if (res?.status === 200) {
        toast.success(res?.message || `${actionType} successful`, {
          duration: 3000,
          position: "top-right",
        });

        refreshWarehousePage();
        return res;
      } else {
        toast.error(res?.message || `${actionType} failed. Please try again!`, {
          duration: 4000,
          position: "top-right",
        });
        return res;
      }
    } catch (err) {
      console.error(`${actionType} API Error:`, err);
      Toast.error(err?.response?.data?.message || "Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
      return null;
    }
  };
  const lineItemLevelShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(LineItemsColInfo);
    setModalTitle("Sub Task");
    setItemLevelModalShow(true);
  };
  const taskColumns = [
    {
      name: "Task Nr",
      selector: (row) => row?.taskNr,
      id: "taskNr",
      cell: (row) => (
        <>
          <button className="btnInfo" onClick={() => detailedPage(row?.taskNr)}>
            {row?.taskNr || "-"}{" "}
          </button>
        </>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Client Name",
      id: "clientName",
      dropDown: true,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold text-primary">
            {/* {row.employeeName} */}
            {row.clientName}
          </span>
        </>
      ),
      selector: (row) => row.clientName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Project Nr",
      id: "projectNr",
      dropDown: true,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1">
            {/* {row.employeeName} */}
            {row.projectNr}
          </span>
        </>
      ),
      selector: (row) => row.projectNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Phases",
      id: "phase",
      dropDown: true,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1">
            {/* {row.employeeName} */}
            {row.phase}
          </span>
        </>
      ),
      selector: (row) => row.phase,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.headerStatus} />
        </>
      ),
      selector: (row) => row.headerStatus || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Delegation",
      selector: (row) => row.taskNr,
      cell: (row) => (
        <button
          className="btn btnTable"
          onClick={() => showDelegation(row?.taskNr)}
        >
          <i className="bi bi-broadcast me-1"></i>
          Delegation
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Module",
    //   id: "apps",
    //   dropDown: true,
    //   cell: (row) => (
    //     <>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.apps} </p>
    //       {/* <p className="m-0 p-0 pt-1 fw-bold ">{row.outCustomerName} </p> */}
    //     </>
    //   ),
    //   selector: (row) => row.apps,
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "Sub Task",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemLevelShowModal(row.subTask)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.subTask?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Start Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{formatDate(row?.startDate)} </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Start Time",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.startTime} </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "End Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{formatDate(row?.endDate)} </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "End Time",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.endTime} </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Action",
      cell: (row) => {
        const status = row?.headerStatus;
        const isCancelled = status === "Cancelled";
        const isDeleted = status === "Deleted";
        const docNo = row.taskNr || row.draftNr;
        return (
          <TableActions
            selectedRow={selectedRowIds.includes(String(docNo))}
            actions={[
              {
                key: "details",
                label: "Details",
                icon: "bi bi-info-circle",
                onClick: () => detailedPage(docNo, row),
              },
              {
                key: "edit",
                label: "Edit",
                icon: "bi bi-pencil-square",
                onClick: () => detailedPage(docNo, row),
                disabled: isDeleted,
              },
              {
                key: "cancel",
                label: "Cancel",
                icon: "bi bi-x-circle",
                onClick: () => cancelModalShow(row, "Cancel"),
                selectRow: true,
                disabled: isCancelled || isDeleted,
              },
              {
                key: "delete",
                label: "Delete",
                icon: "bi bi-trash",
                onClick: () => cancelModalShow(row, "Delete"),
                selectRow: true,
                disabled: isDeleted,
              },
              {
                key: "more",
                label: "More",
                icon: "bi bi-three-dots",
                onClick: () => console.log("More", row),
              },
            ]}
          />
        );
      },
      width: "180px",
    },
  ];
  const LineItemsColInfo = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Task Name",
      selector: (row) => row.subTaskName,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.subTaskName} </p>
            {/* <p className="m-0 p-0">{row.materialDescription} </p> */}
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Assigned To",
      selector: (row) => row.assignedTo,
      sortable: true,
      width: "250px",
    },

    {
      name: "Start Date",
      selector: (row) => row.startDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Start Time",
      selector: (row) => row.startTime,
      sortable: true,
      width: "150px",
    },
    {
      name: "End Date",
      selector: (row) => row.endDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "End Time",
      selector: (row) => row.endTime,
      sortable: true,
      width: "150px",
    },
    {
      name: "Remarks", // calculation
      selector: (row) => row.remarks || "--",
      width: "120px",
    },
  ];

  const showGateRequestModal = () => {
    setModalGateShowStatus(true);
  };
  const hideModalStatus = () => {
    setModalGateShowStatus(false);
  };
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_HRTaskManage_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getTaskList(obj));
  };

  const columnsForFilter = taskColumns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Col xs={12} md={8} lg={8}>
              <h2 className="mainTitle">Task List</h2>
              <p className="subText">Task Directory and Overview </p>
            </Col>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                fetchFunction={ItemService.getTaskList}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>
                <StatisticsContainer
                  statsMode="redux"
                  reduxStats={moduleStats}
                  reduxKey="task"
                  keyName="headerStatus"
                  paginatedList={taskData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                />
              </div>
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Task List</span>
                      <span className="subHeaderTitle">Task </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      <Col
                        xs={{ span: 4, offset: 8 }}
                        md={2}
                        lg={2}
                        className=""
                      >
                        <button
                          className="btnTable"
                          onClick={() => showGateRequestModal()}
                        >
                          Create Task
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={taskColumns}
                          data={filteredData}
                          progressPending={taskData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={taskTable?.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <TaskCreationModel
        show={modalGateShowStatus}
        onHide={() => hideModalStatus()}
        refreshData={refreshWarehousePage}
      />
      <TaskDelegationModal
        show={showDelegationModal}
        onHide={() => setShowDelegationModal(false)}
        taskNr={selectedTaskNr}
      />
      <CancelModal
        title={actionType === "Delete" ? "Delete the Task" : "Cancel the Task"}
        type="Task"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={cancelRows}
        onConfirm={handleCancelAPI}
        docKey="taskNr"
        onSuccess={() => {
          setSelectedRows([]);
          setSelectedRowIds([]);
          setSingleCancelRow(null);
          setActionType("Cancel");
          refreshWarehousePage();
        }}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default TaskManagementList;
